import React, { useEffect, useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
const ItemListAdditionalCosts = ({
  setDataSourceAdditionalCosts,
  dataSourceAdditionalCosts,
  t,
  accounts,
}) => {
  const [count, setCount] = useState(0);
  const columns = [
    {
      title: t.expenseAccount,
      dataIndex: 'expense_account',
      render: (text, record, index) => (
        <Select
          placeholder={t.expenseAccount}
          showSearch
          value={record?.expense_account}
          popupMatchSelectWidth={false}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '').toLocaleLowerCase().includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '')
              .toLowerCase()
              .localeCompare((optionB?.label ?? '').toLowerCase())
          }
          onChange={(value, option) => {
            console.log(option, 'option');
            const newDataSource = [...dataSourceAdditionalCosts];
            newDataSource[index] = {
              ...newDataSource[index],
              account_currency: option?.option?.description,
              exchange_rate: 1.0,
              expense_account: value,
            };
            setDataSourceAdditionalCosts(newDataSource);
          }}
          options={accounts?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
            option: item,
          }))}
        />
      ),
    },
    {
      title: t.amount,
      dataIndex: 'amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.amount}
          type="number"
          min={0}
          value={record?.amount}
          onChange={(e) => {
            const value = e.target.value;
            const newDataSource = [...dataSourceAdditionalCosts];
            newDataSource[index] = {
              ...newDataSource[index],
              amount: value,
              base_amount: value,
            };
            setDataSourceAdditionalCosts(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.description,
      dataIndex: 'description',
      render: (text, record, index) => (
        <Input
          placeholder={t.description}
          value={record.description}
          onChange={(e) => {
            const value = e.target.value;
            const newDataSource = [...dataSourceAdditionalCosts];
            newDataSource[index] = {
              ...newDataSource[index],
              description: value,
            };
            setDataSourceAdditionalCosts(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSourceAdditionalCosts([...dataSourceAdditionalCosts, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceAdditionalCosts.filter(
      (item) => item.key !== key
    );
    setDataSourceAdditionalCosts(newDataSource);
  };
  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceAdditionalCosts}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default ItemListAdditionalCosts;
